import React from 'react';
import { LegalEtherealBackdrop } from './ui/ethereal-shadow';
import './TermsOfService.css';

const TermsOfService = () => {
  return (
    <div className="terms-of-service">
      <LegalEtherealBackdrop />
      <div className="terms-container">
        <div className="terms-header">
          <h1>Terms of Service</h1>
          <p className="last-updated">Last updated: {new Date().toLocaleDateString()}</p>
        </div>

        <div className="terms-content">
          <section className="terms-section">
            <h2>1. Acceptance of Terms</h2>
            <p>By accessing and using this website and our services, you accept and agree to be bound by the terms and provision of this agreement. If you do not agree to abide by the above, please do not use this service.</p>
          </section>

          <section className="terms-section">
            <h2>2. Use License</h2>
            <p>Permission is granted to temporarily download one copy of the materials (information or software) on FuturoCode's website for personal, non-commercial transitory viewing only. This is the grant of a license, not a transfer of title, and under this license you may not:</p>
            <ul>
              <li>Modify or copy the materials</li>
              <li>Use the materials for any commercial purpose or for any public display</li>
              <li>Attempt to decompile or reverse engineer any software contained on the website</li>
              <li>Remove any copyright or other proprietary notations from the materials</li>
              <li>Transfer the materials to another person or "mirror" the materials on any other server</li>
            </ul>
          </section>

          <section className="terms-section">
            <h2>3. Service Description</h2>
            <p>FuturoCode provides web development, digital marketing, and technology consulting services. Our services include but are not limited to:</p>
            <ul>
              <li>Website design and development</li>
              <li>E-commerce solutions</li>
              <li>Digital marketing and SEO</li>
              <li>Mobile app development</li>
              <li>Technology consulting</li>
              <li>Maintenance and support services</li>
            </ul>
          </section>

          <section className="terms-section">
            <h2>4. Project Terms</h2>
            <p>When engaging our services for a project:</p>
            <ul>
              <li>All projects require a signed agreement and deposit before work begins</li>
              <li>Project timelines are estimates and may vary based on complexity and client feedback</li>
              <li>Client approval is required at each major milestone</li>
              <li>Final payment is due upon project completion and delivery</li>
              <li>Revisions are included as specified in the project agreement</li>
            </ul>
          </section>

          <section className="terms-section">
            <h2>5. Payment Terms</h2>
            <p>Payment terms for our services:</p>
            <ul>
              <li>50% deposit required to begin work on new projects</li>
              <li>Remaining balance due upon project completion</li>
              <li>Payment methods accepted: Credit card, bank transfer, PayPal</li>
              <li>Late payments may incur additional fees</li>
              <li>All prices are in USD unless otherwise specified</li>
            </ul>
          </section>

          <section className="terms-section">
            <h2>6. Intellectual Property</h2>
            <p>Upon full payment, clients own the final deliverables. However:</p>
            <ul>
              <li>FuturoCode retains the right to showcase work in our portfolio</li>
              <li>Third-party assets (fonts, images, etc.) remain under their respective licenses</li>
              <li>Custom code and designs become client property upon final payment</li>
              <li>FuturoCode may use project work for marketing purposes with client permission</li>
            </ul>
          </section>

          <section className="terms-section">
            <h2>7. Client Responsibilities</h2>
            <p>Clients are responsible for:</p>
            <ul>
              <li>Providing timely feedback and approvals</li>
              <li>Supplying necessary content and materials</li>
              <li>Ensuring content accuracy and legal compliance</li>
              <li>Maintaining backups of their data</li>
              <li>Providing access to necessary accounts and systems</li>
            </ul>
          </section>

          <section className="terms-section">
            <h2>8. Limitation of Liability</h2>
            <p>FuturoCode shall not be liable for any indirect, incidental, special, consequential, or punitive damages, including without limitation, loss of profits, data, use, goodwill, or other intangible losses, resulting from your use of our services.</p>
          </section>

          <section className="terms-section">
            <h2>9. Warranty Disclaimer</h2>
            <p>The materials on FuturoCode's website are provided on an 'as is' basis. FuturoCode makes no warranties, expressed or implied, and hereby disclaims and negates all other warranties including without limitation, implied warranties or conditions of merchantability, fitness for a particular purpose, or non-infringement of intellectual property or other violation of rights.</p>
          </section>

          <section className="terms-section">
            <h2>10. Termination</h2>
            <p>Either party may terminate a project agreement with written notice. Upon termination:</p>
            <ul>
              <li>Client is responsible for payment of work completed to date</li>
              <li>FuturoCode will deliver all completed work</li>
              <li>Any deposits are non-refundable unless otherwise specified</li>
              <li>Both parties agree to return any confidential information</li>
            </ul>
          </section>

          <section className="terms-section">
            <h2>11. Privacy and Confidentiality</h2>
            <p>We respect your privacy and will protect confidential information. Please refer to our Privacy Policy for details on how we handle your personal information.</p>
          </section>

          <section className="terms-section">
            <h2>12. Governing Law</h2>
            <p>These terms shall be governed by and construed in accordance with the laws of the jurisdiction in which FuturoCode operates, without regard to its conflict of law provisions.</p>
          </section>

          <section className="terms-section">
            <h2>13. Changes to Terms</h2>
            <p>FuturoCode reserves the right to modify these terms at any time. Changes will be effective immediately upon posting on the website. Your continued use of our services constitutes acceptance of the modified terms.</p>
          </section>

          <section className="terms-section">
            <h2>14. Contact Information</h2>
            <p>If you have any questions about these Terms of Service, please contact us at:</p>
            <div className="contact-info">
              <p><strong>Email:</strong> guevaramauricio754@gmail.com</p>
              <p><strong>Phone:</strong> +1 (336) 569-9022</p>
              <p><strong>Address:</strong> Winston-Salem, NC</p>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
};

export default TermsOfService; 